import React from "react";

import Image from "next/image";
import NoPhotoImg from "public/images/no-photo.png";

import { CardActionArea } from "@mui/material";

import { clsxm } from "@/utils/tailwindMerge";

type PropTypes = {
  src?: string;
  alt: string;
  className?: string;
  onClick?: () => void;
  id?: string;
  ["data-testid"]?: string;
};

export const ProfileAvatar: React.FC<PropTypes> = ({
  src,
  alt,
  className,
  onClick,
  id,
  ["data-testid"]: dataTestId,
}) => {
  const [isError, setIsError] = React.useState(false);
  const enableErrorState = () => setIsError(true);

  const imageSrc = (isError ? NoPhotoImg.src : src) ?? NoPhotoImg.src;

  return (
    <CardActionArea
      data-testid={dataTestId}
      onClick={onClick}
      className={className}
    >
      <Image
        src={imageSrc}
        alt={alt}
        className={clsxm("object-cover", !isError && src ? "object-top" : "")}
        id={id}
        onError={enableErrorState}
        fill
        unoptimized
        priority
      />
    </CardActionArea>
  );
};
